import React from "react";
import TabbedPage from "../../../Elements/TabbedPage";
import AssignmentPaymentsAdmin from "./AssignmentPaymentsAdmin";
import ExcludedPayEvaluatorsAdmin from "./ExcludedPayEvaluatorsAdmin";
import VoidedPaymentsAdmin from "./VoidedPaymentsAdmin";

export default class AssignmentPaymentsParentAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      window: null,
    };
  }

  componentDidMount() {}

  tabs = [
    { label: "Assignment Payments", id: "assignmentpayments", icon: "fa-solid fa-credit-card", component: <AssignmentPaymentsAdmin /> },
    { label: "Voided Payments", id: "voidedpayments", icon: "fa-solid fa-credit-card", component: <VoidedPaymentsAdmin /> },
    { label: "Excluded PS", id: "excludedevaluators", icon: "fa-solid fa-memo-circle-info", component: <ExcludedPayEvaluatorsAdmin /> },
  ];

  render() {
    return (
      <div className="contentwrapper">
        {this.state.window}
        <div className="bg-white p-1">
          <div className="TabbedPage">
            <TabbedPage
              tabs={this.tabs}
              removeSearchParametersOnTabChange={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
